const module = { name: 'Fandango/queryUtil', exports: {} }; const exports = module.exports;



import { Fandango_sanitizer as sanitizer } from 'require-core';



const RegExes = {
    LEADING_QUERY_SEPARATOR: /^[?&]/,
}
function queryStringToArray(str) {
    if (!str || typeof str !== 'string') {
        return [];
    }
    return str.replace(RegExes.LEADING_QUERY_SEPARATOR, '')
        .split('&')
        .filter(value => value.trim().length);
}
function arrayToObject(ary) {
    if (!Array.isArray(ary)) {
        return {};
    }
    return ary
        .filter(kvp => typeof kvp === 'string')
        .reduce((result, kvp) => {
        let [key, value] = kvp.split('=');
        key = key.trim();
        if (key) {
            result[key] = value;
        }
        return result;
    }, {});
}
function queryStringToObject(str) {
    return arrayToObject(queryStringToArray(str));
}
function objectToQueryString(obj) {
    if (!obj || typeof obj !== 'object') {
        return '';
    }
    return Object.keys(obj)
        .map(key => key + '=' + obj[key])
        .join('&');
}
function getParamValue(paramName, searchParams) {
    searchParams = typeof searchParams === 'string' ? searchParams : window.location.search;
    const params = queryStringToObject(searchParams);
    const value = params[paramName];
    return value;
}
function getParam(paramName, searchParams) {
    const value = getParamValue(paramName, searchParams);
    return value === undefined ? null : sanitizer.text(value);
}
function getParamUnsanitized(paramName, searchParams) {
    const value = getParamValue(paramName, searchParams);
    return value === undefined ? null : value;
}
function setParam(paramName, value, searchParams) {
    paramName = ('' + paramName).trim();
    if (!paramName || value === undefined) {
        return searchParams || '';
    }
    const remove = value === null;
    paramName = encodeURIComponent(paramName);
    value = encodeURIComponent(value);
    searchParams = typeof searchParams === 'string' ? searchParams : window.location.search;
    const params = queryStringToObject(searchParams);
    if (remove) {
        delete params[paramName];
    }
    else {
        params[paramName] = value;
    }
    return objectToQueryString(params);
}
function removeParam(paramName, searchParams) {
    searchParams = typeof searchParams === 'string' ? searchParams : window.location.search;
    const result = setParam(paramName, null, searchParams);
    if (!result) {
        return '';
    }
    return result.indexOf('?') > -1 ? result : '?' + result;
}
function replaceParam(paramName, value, searchParams) {
    searchParams = typeof searchParams === 'string' ? searchParams : window.location.search;
    const params = queryStringToObject(searchParams);
    if (params[paramName] === undefined) {
        return searchParams;
    }
    params[paramName] = value;
    const result = objectToQueryString(params);
    return result.length ? '?' + result : '';
}
function setHash(url, anchor) {
    if (!url || !anchor) {
        return null;
    }
    return url.split('#')[0] + '#' + anchor;
}
function extendLegacy(publicInterface, area) {
    window.Fandango = window.Fandango || {};
    const { Fandango } = window;
    if (!Fandango[area]) {
        Fandango[area] = publicInterface;
    }
}
module.exports = {
    getParam,
    getParamUnsanitized,
    getParamValue,
    setParam,
    removeParam,
    replaceParam,
    setHash,
};
extendLegacy(module.exports, 'queryUtil');
export default module.exports;